var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.6 5.515c-.92.408-1.907.684-2.945.808 1.06-.635 1.872-1.64 2.255-2.838-.99.588-2.09 1.015-3.257 1.245-.936-.997-2.27-1.62-3.744-1.62-2.833 0-5.13 2.296-5.13 5.13 0 .4.046.792.133 1.168-4.262-.214-8.042-2.256-10.57-5.36-.443.76-.696 1.64-.696 2.58 0 1.78.905 3.35 2.282 4.27-.842-.028-1.633-.26-2.324-.643v.065c0 2.485 1.768 4.558 4.114 5.03-.43.116-.884.18-1.35.18-.33 0-.653-.033-.966-.093.653 2.038 2.547 3.52 4.79 3.562-1.754 1.375-3.966 2.195-6.37 2.195-.413 0-.82-.024-1.223-.072 2.27 1.456 4.967 2.305 7.863 2.305 9.434 0 14.593-7.815 14.593-14.593 0-.222-.005-.443-.015-.664 1.004-.723 1.873-1.626 2.56-2.655zm0 0"}));
}

TwitterIcon.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
